import Background from "../../assets/images/background/banner.jpg";
import "./director.css";
import { Link } from 'react-router-dom';
import { motion} from "framer-motion";
import SEO from '../seo';

//images Director
import NileshSir from "../../assets/images/Directors/nilesh-parmar-img.jpg";
import Komalmam from "../../assets/images/Directors/komal-parmar.jpg";
export default function About() {
    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];  

    return (
        <div>
            <SEO
                title="Directors"
                description="Entrepreneur &amp; Managing Director Mr. Nilesh Parmar Nilesh Parmar is a dynamic entrepreneur and the driving force behind Horizon Webinfo Pvt Ltd, a leading IT solutions company that has been revolutionizing the digital landscape since its inception. Entrepreneurial Vision: With an unwavering passion for technology and innovation, Nilesh founded Horizon Webinfo Pvt Ltd in Mr. [&hellip;]"
                canonical="https://www.hwplindia.com/company/directors/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/nilesh-parmar-img.jpg"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Directors</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Company</li>
                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Directors</li>
                    </ul>
                </div>
            </section>
            <section className="director-section">
                <div className="container">
                    <motion.div
                        className="director-image"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.5 }}
                    >
                        <img src={NileshSir} alt="Nilesh Parmar" />
                    </motion.div>

                    <motion.div
                        className="director-content"
                        initial={{ opacity: 0, x: 100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.5 }}
                    >
                        <h4 className="designation">ENTREPRENEUR & MANAGING DIRECTOR</h4>
                        <h2 className="name">Mr. Nilesh Parmar</h2>

                        <p>
                           Mr. Nilesh Parmar is a visionary entrepreneur and the driving force behind Horizon Webinfo Pvt. Ltd., a leading IT solutions company that has been transforming the digital landscape through innovation, reliability, and technology excellence.
                        </p>

                        <p>
                            <strong>Entrepreneurial Vision :</strong> With a deep passion for technology and innovation, Mr. Parmar founded Horizon Webinfo Pvt. Ltd. with a clear mission—to empower businesses through scalable, future-ready digital solutions. His entrepreneurial journey reflects strategic foresight, resilience, and an unwavering commitment to delivering measurable value to clients across global markets.
                        </p>

                        <p className='p-director'>
                            <strong>Leadership at Horizon Webinfo Pvt. Ltd. :</strong> As the Managing Director, Mr. Parmar has played a pivotal role in shaping Horizon Webinfo into a trusted IT partner for businesses of all sizes. Under his leadership, the company has evolved into a full-service technology firm offering comprehensive solutions including website development, custom software development, ERP & CRM systems, mobile applications, and IT consulting services.
                        </p>

                        <p>
                            <strong>Innovative Solutions for a Digital Future : </strong> Driven by a strong innovation mindset, Mr. Parmar continuously guides the organization toward adopting emerging technologies and best practices. His strategic direction ensures that Horizon Webinfo delivers robust, scalable, and secure digital solutions—helping clients stay competitive in an ever-changing technological environment.


                        </p>

                        <p>
                            <strong>Client-Centric Approach :</strong> Mr. Parmar strongly believes that long-term success is built on trust, transparency, and deep client understanding. His client-first approach focuses on building meaningful partnerships, addressing unique business challenges, and delivering customized solutions that generate real business impact and sustainable growth.
                        </p>

                        <p>
                            <strong>Technology Enthusiast & Thought Leader :</strong> Beyond corporate leadership, Mr. Parmar is an active technology enthusiast and thought leader in the IT ecosystem. He regularly engages with industry trends, emerging technologies, and digital transformation strategies. His insights and vision continue to contribute to Horizon Webinfo’s strong reputation as an innovative and forward-thinking technology partner.
                        </p>
                    </motion.div>
                </div>
            </section>
            <section className="director-section director-section1">
                <div className="container">
                    <motion.div
                        className="director-image2"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.5 }}
                    >
                        <img src={Komalmam} alt="Komal Parmar" />
                    </motion.div>

                    <motion.div
                        className="director-content"
                        initial={{ opacity: 0, x: 100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.5 }}
                    >
                        <h4 className="designation">CREATIVE DIRECTOR & VISIONARY LEADER</h4>
                        <h2 className="name">Mrs. Komal Parmar</h2>

                        <p>
                           Mrs. Komal Parmar is a       visionary Creative Director and a key force behind the creative excellence of Horizon Webinfo Pvt. Ltd., a pioneering IT solutions company established in 2005. Her leadership blends artistic innovation with strategic thinking, shaping impactful digital experiences for brands across industries.
                        </p>

                        <p>
                            <strong>Creative Leadership & Strategic Vision :</strong> As the Creative Director, Mrs. Parmar brings a unique blend of creativity, innovation, and design leadership to Horizon Webinfo. With a sharp eye for evolving design trends and a passion for pushing creative boundaries, she has been instrumental in defining the company’s visual identity and creative direction.
                        </p>

                        <p className='p-director'>
                            <strong>Founding Vision & Artistic Innovation : </strong> Since the inception of Horizon Webinfo in 2005, Mrs. Parmar has played a crucial role in transforming ideas into visually compelling and meaningful digital solutions. Her founding philosophy is rooted in the belief that design is not merely aesthetic—it is a powerful medium to communicate brand values, build emotional connections, and drive engagement.
                        </p>

                        <p>
                            <strong>Client-Centric Creative Excellence :</strong> Renowned for her client-first approach, Mrs. Parmar believes that every brand has a unique story to tell. Her ability to deeply understand client objectives and translate them into compelling visual narratives has resulted in highly customized and result-driven digital experiences.


                        </p>

                        <p>
                            <strong>Innovative Digital Experiences :</strong> Under her creative leadership, Horizon Webinfo has consistently delivered innovative and immersive digital solutions—from visually striking websites to engaging multimedia content. Her commitment to design excellence and innovation has positioned the company as a trusted creative and technology partner in a competitive digital landscape.
                        </p>

                        <p>
                            <strong>Technology-Driven Creativity : </strong> In an ever-evolving digital world, Mrs. Parmar seamlessly integrates emerging technologies with creative design. Her forward-thinking approach ensures that Horizon Webinfo’s solutions are not only visually powerful but also technologically advanced, delivering intuitive, engaging, and future-ready user experiences.


                        </p>
                    </motion.div>
                </div>
            </section>
        </div>
    );
}